"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transactionalRiskScorecardSchema = void 0;
exports.transactionalRiskScorecardSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        /* eslint-disable-next-line no-template-curly-in-string */
        errorMessage: '- should not have additional property ${0#}',
    },
    required: [
        'cmhcAccountNumber',
        'applicationIDTimestamp',
        'typeID',
        'recordCreatedTimestamp',
        'recordUpdatedTimestamp',
        'recordUpdatedUserID',
        'scorecardAddressPeriodPoints',
        'scorecardApplicantOccupationPoints',
        'scorecardCoApplicantOccupationPoints',
        'scorecardLoanToValuePoints',
        'scorecardTotalDebtServicePoints',
        'scorecardBankTimePoints',
        'scorecardCreditHistoryDurationPoints',
        'scorecardTimeToFirstTradePoints',
        'scorecardCreditBureauInquiriesGreaterThanTheCurrentPoints',
        'scorecardResidentialStatusPoints',
        'scorecardWorstPastDueTimePoints',
        'scorecardWorstStatusPoints',
        'scorecardEmploymentPeriodPoints',
        'scorecardIndustryApplicantPoints',
        'scorecardIndustryCoApplicantPoints',
        'scorecardLatestInquiryPoints',
        'scorecardModelDependentPoints',
        'scorecardModelRatingTypeCode',
        'scorecardModelTotalPoints',
        'scorecardOpenDebtPoints',
        'scorecardTypeCode',
        'scorecardOutstandingDebtPoints',
        'scorecardPublicRecordPoints',
        'scorecardTotalInquiriesPoints',
        'scorecardUnfavourableCreditPoints',
        'scorecardWorstCreditPoints',
    ],
    properties: {
        cmhcAccountNumber: {
            type: 'number',
            minimum: 0,
            maximum: 999999999999,
            errorMessage: 'should be a number with up to 12 digits',
        },
        applicationIDTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        typeID: {
            type: 'integer',
            minimum: -32767,
            maximum: 32767,
            errorMessage: 'should be an integer between 0 and 32767',
        },
        recordCreatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        recordUpdatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        recordUpdatedUserID: {
            type: 'string',
            minLength: 0,
            maxLength: 8,
            errorMessage: 'should have maximum length of 8 characters',
        },
        scorecardAddressPeriodPoints: {
            type: 'number',
            maximum: 999,
            minimum: -999,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        scorecardApplicantOccupationPoints: {
            type: 'number',
            maximum: 999,
            minimum: -999,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        scorecardCoApplicantOccupationPoints: {
            type: 'number',
            maximum: 999,
            minimum: -999,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        scorecardLoanToValuePoints: {
            type: 'number',
            maximum: 999,
            minimum: -999,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        scorecardTotalDebtServicePoints: {
            type: 'number',
            maximum: 999,
            minimum: -999,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        scorecardBankTimePoints: {
            type: 'number',
            maximum: 999,
            minimum: -999,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        scorecardCreditHistoryDurationPoints: {
            type: 'number',
            maximum: 999,
            minimum: -999,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        scorecardTimeToFirstTradePoints: {
            type: 'number',
            maximum: 999,
            minimum: -999,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        scorecardCreditBureauInquiriesGreaterThanTheCurrentPoints: {
            type: 'number',
            maximum: 999,
            minimum: -999,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        scorecardResidentialStatusPoints: {
            type: 'number',
            maximum: 999,
            minimum: -999,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        scorecardWorstPastDueTimePoints: {
            type: 'number',
            maximum: 999,
            minimum: -999,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        scorecardWorstStatusPoints: {
            type: 'number',
            maximum: 999,
            minimum: -999,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        scorecardEmploymentPeriodPoints: {
            type: 'number',
            maximum: 999,
            minimum: -999,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        scorecardIndustryApplicantPoints: {
            type: 'number',
            maximum: 999,
            minimum: -999,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        scorecardIndustryCoApplicantPoints: {
            type: 'number',
            maximum: 999,
            minimum: -999,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        scorecardLatestInquiryPoints: {
            type: 'number',
            maximum: 999,
            minimum: -999,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        scorecardModelDependentPoints: {
            type: 'number',
            maximum: 999,
            minimum: -999,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        scorecardModelRatingTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        scorecardModelTotalPoints: {
            type: 'number',
            maximum: 99999,
            minimum: -99999,
            errorMessage: 'should be a number with up to 5 digits in total',
        },
        scorecardOpenDebtPoints: {
            type: 'number',
            maximum: 999,
            minimum: -999,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        scorecardTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        scorecardOutstandingDebtPoints: {
            type: 'number',
            maximum: 999,
            minimum: -999,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        scorecardPublicRecordPoints: {
            type: 'number',
            maximum: 999,
            minimum: -999,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        scorecardTotalInquiriesPoints: {
            type: 'number',
            maximum: 999,
            minimum: -999,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        scorecardUnfavourableCreditPoints: {
            type: 'number',
            maximum: 999,
            minimum: -999,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        scorecardWorstCreditPoints: {
            type: 'number',
            maximum: 999,
            minimum: -999,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
    },
};
